import { useRef, useCallback } from "react";

const useDebounce = <T extends (...args: Parameters<T>) => void>(
  callback: T,
  timeInMilli: number,
) => {
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);

  const debouncedCallback = useCallback(
    (...args: Parameters<T>) => {
      if (timeoutIdRef.current) {
        clearTimeout(timeoutIdRef.current);
      }

      const newTimeoutId = setTimeout(() => {
        callback(...args);
      }, timeInMilli);

      timeoutIdRef.current = newTimeoutId;
    },
    [callback, timeInMilli],
  );

  return debouncedCallback;
};

export default useDebounce;
